<template>
  <div
    class="notifications-item-chat-reaction-avatar"
    :class="{ 'notifications-item-chat-reaction-avatar_sm': small }"
  >
    <div v-if="isOwnerVisible" class="notifications-item-chat-reaction-avatar__user">
      <ProspectAvatar v-if="prospect" disable-tooltip small :prospect="prospect" />
      <UserAvatar v-else-if="user" small :user="user" />
    </div>
    <div v-else-if="isOwnerHidden" class="notifications-item-chat-reaction-avatar__anonymous">
      {{ anonymousReplyLetter }}
    </div>
    <LogoRound v-else-if="isOwnerModerator" class="notifications-item-chat-reaction-avatar__moderator" />
  </div>
</template>

<script>
import ProspectAvatar from '@/components/modules/prospects/ProspectAvatar.vue'
import UserAvatar from '@/components/modules/users/UserAvatar.vue'
import LogoRound from '@/assets/icons/LogoRound.vue'
import { NotificationModel } from '@/models/notification'
import { NotificationType } from '@/common/enums'

export default {
  name: 'NotificationsItemChatReactionProfile',
  components: { LogoRound, UserAvatar, ProspectAvatar },
  props: {
    notification: { type: NotificationModel, required: true },
    small: { type: Boolean, default: false }
  },
  computed: {
    isOwnerVisible() {
      return !this.isOwnerHidden && !this.isOwnerModerator
    },
    isOwnerHidden() {
      return (
        !this.reaction.isModerator &&
        (this.chat.isAnonymous ||
          (this.notification.type === NotificationType.CHAT_RESPONSE_REACTION &&
            this.response.anonymousState))
      )
    },
    isOwnerModerator() {
      return (
        this.reaction.isModerator &&
        (this.chat.isAnonymous ||
          (this.notification.type === NotificationType.CHAT_RESPONSE_REACTION &&
            this.response.anonymousState))
      )
    },
    anonymousReplyLetter() {
      return this.$t('forum.response.anonymous_reply_user_name').slice(0, 1)
    },
    notificationPayload() {
      return this.notification.payload.chatResponseReaction || this.notification.payload.chatThreadReaction
    },
    prospect() {
      return this.reaction.prospect
    },
    user() {
      return this.reaction.user
    },
    chat() {
      return this.notificationPayload.chat
    },
    reaction() {
      return this.notificationPayload.reaction
    },
    response() {
      return this.notificationPayload.response
    },
    thread() {
      return this.notificationPayload.thread
    }
  }
}
</script>

<style scoped lang="scss">
.notifications-item-chat-reaction-avatar {
  &__user {
    @apply w-6 h-6 flex-shrink-0;
    @screen md {
      @apply w-8 h-8;
    }
  }
  &__anonymous {
    @apply w-6 h-6 rounded-full object-cover bg-neutral-01-400 text-body-02 text-white flex items-center justify-center;
    @screen md {
      @apply w-8 h-8;
    }
  }
  &__moderator {
    @apply w-6 h-6 rounded-full text-body-02 text-white flex items-center justify-center;
    @screen md {
      @apply w-8 h-8;
    }
  }

  &.notifications-item-chat-reaction-avatar_sm {
    .notifications-item-chat-reaction-avatar__user,
    .notifications-item-chat-reaction-avatar__anonymous,
    .notifications-item-chat-reaction-avatar__moderator {
      @apply w-5 h-5;
      @screen md {
        @apply w-6 h-6;
      }
    }
    .notifications-item-chat-reaction-avatar__anonymous,
    .notifications-item-chat-reaction-avatar__moderator {
      font-size: 12px;
      line-height: 1;
    }
  }
}
</style>
